import Text from '~/components/Text';

interface Props {
  text: string | React.ReactNode;
}

const SidePanelTitle = ({ text }: Props) => {
  return (
    <Text as="span" type="title" theme="navs" className="text-md font-semibold sm:block">
      {text}
    </Text>
  );
};

export default SidePanelTitle;
